import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "22",
  viewBox: "0 0 21 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.1701 7.0556L6.73359 11.2675C5.28687 12.184 3.38248 11.1634 3.38248 9.4717V9.33132H0.847526C0.379268 9.33132 0 8.95848 0 8.49818C0 8.03829 0.379268 7.66504 0.847526 7.66504H3.38248V3.94633H0.847526C0.379268 3.94633 0 3.5735 0 3.11319C0 2.6533 0.379268 2.28006 0.847526 2.28006H3.38248V2.14009C3.38248 0.448405 5.28687 -0.572189 6.73359 0.344262L13.1701 4.55619C17.4874 4.55619 21 8.00913 21 12.2531V20.7503C21 21.4405 20.4309 22 19.7287 22C19.0261 22 18.4574 21.4405 18.4574 20.7503V12.2531C18.4574 9.38713 16.0856 7.0556 13.1701 7.0556Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }